'use strict';

const SectionPickerPresenter = require('../presenters/sectionpicker');

const PickerListView = require('./pickerlist');

const SectionsView = require('./sections');

class SectionPickerView extends PickerListView {
  initialize() {
    this.module = 'glive_booking_redesign';
    this.presenter = SectionPickerPresenter;
    this.contentView = SectionsView;
    this.templateName = 'sectionpicker';
  }

  className() {
    return 'picker glive-picker collapsed sections';
  }

  attributes() {
    return { 'data-bhw': 'GliveBookingDealBookerSections' };
  }
  show() {
    const isTouch = this.collection.meta('isTouch');
    const limit = isTouch ? 3 : 4;
    return super.show(limit);
  }
}

module.exports = SectionPickerView;
